<div class="modal-body text-center">
    <p><span [innerHTML]="message"></span></p>
    <hr>
    <button type="button" class="btn btn-light" (click)="confirm()">Yes</button>
    <button type="button" class="btn btn-primary" (click)="decline()">No</button>
</div>